/**
 * @description Utility function to get the initials of a user
 * @param firstName - First name of the user
 * @param lastName - Last name of the user
 * @returns Initials of the user
 */

export const getUserInitials = (
  firstName?: string,
  lastName?: string,
): string => {
  if (!firstName || !lastName) return "";
  return `${firstName.split("")[0]}${lastName.split("")[0]}`
    .toUpperCase()
    .trim();
};

export const getUserFullName = (
  firstName?: string,
  lastName?: string,
): string => {
  if (!firstName || !lastName) return "";
  return `${firstName} ${lastName}`.trim();
};

export const getInitialsFromFullname = (fullname: string): string => {
  const trimmedName = fullname.trim();
  if (!trimmedName) return "";

  const emojiRegex = /^(\p{Emoji}[\uFE0F\u200D\p{Emoji}]*)/u;
  const firstEmoji = trimmedName.match(emojiRegex);
  if (firstEmoji) return firstEmoji[0];

  const parts = trimmedName.split(/\s+/);
  if (parts.length === 1) {
    const firstChar = Array.from(parts[0])[0];
    return firstChar ? firstChar.toUpperCase() : "";
  }

  const firstInitial = Array.from(parts[0])[0];
  const lastInitial = Array.from(parts[parts.length - 1])[0];
  return `${firstInitial}${lastInitial}`.toUpperCase();
};
